import * as React from 'react';
import classNames from 'classnames';
import style from './flex.scss';

type DivElementProps = JSX.IntrinsicElements['div'];

export interface FlexProps extends DivElementProps {
  wrap?: string;
  flex?: string;
  inline?: boolean;
  direction?: string;
  alignItems?: string;
  alignContent?: string;
  justifyContent?: string;
  wrapperComponent?: string | React.ComponentClass;
  className?: string;
}

export function Flex({
  wrap = 'nowrap',
  flex,
  inline = false,
  direction,
  alignItems,
  alignContent,
  justifyContent,
  wrapperComponent = 'div',
  style: propsStyle = {},
  children,
  className = '',
  ...restProps
} : FlexProps) {

  const flexProps: any = {
    style: Object.assign({}, propsStyle, {
      flexDirection: direction,
      flexWrap: wrap,
      flex,
      alignItems,
      alignContent,
      justifyContent,
    }),
    className: classNames(className, style.flex, {[style.inline]: inline}),
    ...restProps,
  };

  return React.createElement(
    wrapperComponent,
    flexProps,
    children,
  );
}

export default Flex;
